// DLC Client Config
// import { isProd } from "../env";
import template from "./_template";

const dlc_config = {
  name: "dlc",
  disabled_features: {
    ...template.disabled_features,
  },
  enabled_features: {
    ...template.enabled_features,
    dataset_dip: true, // DLC-147 Whether to ENABLE client to "dip" datasets to find mobile phone numbers
    sso_microsoft: true, // Whether Login page should display the Microsoft SSO button
    campaign_templates: true, // Whether to ENABLE the templates feature for the client DLC-78
  },
  sms: {
    short_codes: [
      // { label: "94230", value: "94230" }, // REST DLC-109 Removed as certification has completed for their shortcodes
      { label: "DLCNOW - Outages", value: "352669" },
      // { label: "TXTDLC - Billing", value: "898352" }, // DLC-109 Removed as this SC intended as Billing, not Ad Hoc
    ],
  },
  voice: {
    premium_options: [], // "all" || "premium" | "french" | "german" | "spanish"
    caller_id_options: [
      { label: "Select a phone number", isDisabled: true },
      { label: "Residential Customer Service: 412-393-7100", value: "4123937100" },
      { label: "Business Customer Service: 412-393-7300", value: "4123937300" },
      { label: "Outages: 412-393-7000", value: "4123937000" },
      { label: "Billing/Payment: 412-393-7200", value: "4123937200" },
      { label: "Start/Stop/Transfer: 412-393-4343", value: "4123934343" },
      { label: "Energy Efficiency: 1-888-928-8539", value: "8889288539" },
    ],
  },
};

export default dlc_config;
